import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h4", { class: "p-mb-0" }, "Nouveau pointage", -1)

import { EmployeeModelFragment } from "@/graphql/types";
import {
  CreatePointingType,
  useCreatePointing,
} from "./hooks/useCreatePointing";
import PointingForm from "./PointingForm.vue";
import { getFullNames } from "@/utils/poiting";


export default /*#__PURE__*/_defineComponent({
  __name: 'CreatePointing',
  props: {
    visible: { type: Boolean, default: false },
    employees: {},
    createdAt: {},
    type: {}
  },
  emits: ["update:visible", "on-created"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const props = __props;

const { submit, form, pointingFormRef, submitForm, minDate } =
  useCreatePointing({
    props,
    emit,
  });

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: _ctx.visible,
    containerStyle: { width: '50vw' },
    "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:visible', $event)))
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", null, [
        _hoisted_1,
        _createTextVNode(" " + _toDisplayString(_unref(getFullNames)(_ctx.employees)), 1)
      ])
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:visible', false))),
        label: _ctx.$t('cancel'),
        icon: "pi pi-times",
        class: "p-button-text"
      }, null, 8, ["label"]),
      _createVNode(_component_Button, {
        disabled: _unref(form).times.$hasError,
        "icon-pos": "right",
        label: _ctx.$t('save'),
        onClick: _unref(submitForm),
        icon: "pi pi-save",
        class: "p-button-success"
      }, null, 8, ["disabled", "label", "onClick"])
    ]),
    default: _withCtx(() => [
      _createVNode(PointingForm, {
        onOnSubmit: _unref(submit),
        times: _unref(form).times.$value,
        "onUpdate:times": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).times.$value) = $event)),
        date: _ctx.createdAt,
        min: _unref(minDate),
        ref_key: "pointingFormRef",
        ref: pointingFormRef
      }, null, 8, ["onOnSubmit", "times", "date", "min"])
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})